import { call } from '../../utils/serviceUtils';
import {
  APPROVALS,
  APPROVALS_COUNT,
  APPROVALS_GET_ALL,
  APPROVALS_GET_WAITINGS,
  APPROVALS_GET_ACTIVES,
  APPROVALS_GET_COMPLETEDS,
  APPROVALS_GET_CANCELEDS,
  APPROVAL_FILE_GET,
  APPROVAL_SIGNED_FILE_GET,
  APPROVAL_ADDITIONAL_FILE_GET,
  APPROVAL_FILE_VERIFY,
  APPROVAL_SIGNERS,
  APPROVALS_FROM_TEMPLATE,
  SIGNING_SERVICE_ROUTING_GET,
  USERS_BY_CUSTOMER_NUMBER,
  CURRENT_USER
  } from '../../config/paths';

export function createApproval(data) {
  return call.post(APPROVALS,data);
}

export function createApprovalFromTemplate(data) {
  return call.post(APPROVALS_FROM_TEMPLATE,data);
}

export function getApprovalsCount() {
  return call.get(APPROVALS_COUNT,
    {});
}

export function getAll() {
  return call.get(APPROVALS_GET_ALL,
    {});
}

export function getWaitings() {
  return call.get(APPROVALS_GET_WAITINGS,
    {});
}

export function getActives() {
  return call.get(APPROVALS_GET_ACTIVES,
    {});
}

export function getCompleteds() {
  return call.get(APPROVALS_GET_COMPLETEDS,
    {});
}

export function getCanceleds() {
  return call.get(APPROVALS_GET_CANCELEDS,
    {});
}

export function getApprovalDetail(id) {
  return call.get(APPROVALS+'/'+id,
    {});
}

export function getApprovalFile(id) {
  return call.get(APPROVAL_FILE_GET+'/'+id,
    {});
}

export function getSignedFile(id) {
  return call.get(APPROVAL_SIGNED_FILE_GET+'/'+id,
    {});
}
export function getAdditionalFile(id) {
  return call.get(APPROVAL_ADDITIONAL_FILE_GET+'/'+id,
    {});
}

export function verifyApprovalFile(id) {
  return call.get(APPROVAL_FILE_VERIFY+'/'+id,
    {});
}

export function approveInternalSigner(data) {
  return call.putWithTimeout(APPROVAL_SIGNERS+'/approve',data,60000);
}

export function cancelInternalSigner(data) {
  return call.put(APPROVAL_SIGNERS+'/cancel',data);
}

export function getUsers() {
  return call.get(APPROVAL_SIGNERS+'/users',
    {});
}

export function signingInitialize(data) {
  return call.putWithTimeout(APPROVAL_SIGNERS+'/signingInitialize',data,60000);
}

export function cancelApproval(data) {
  return call.put(APPROVALS+'/cancel',data);
}

export function sign(data) {
  return call.putWithTimeout(APPROVAL_SIGNERS+'/sign',data,60000);
}

 export function getSigningServiceRouter(){
   return call.get(SIGNING_SERVICE_ROUTING_GET + '/serviceRouter', {});
 }

export function getUsersByCustomerNumber() {
  return call.get(USERS_BY_CUSTOMER_NUMBER, {});
}

export function getCurrentUser() {
  return call.get(CURRENT_USER, {});
}